import React from 'react';
import { Box } from '@mui/material';
import { useTokens } from 'theme';

/**
 * The product mark: a rhombus on a rounded tile.
 * `tone` picks the tile for the ground it sits on — `accent` (lime, the
 * sidebar), `light` (white, on a dark panel) or `ink` (dark, on the page).
 */
export default function BrandMark({ size = 24, tone = 'accent' }) {
  const t = useTokens();
  const [tile, mark] = {
    accent: [t.accent, t.onAccent],
    light:  [t.onChrome, t.chrome],
    ink:    [t.ink, t.surface],
  }[tone];
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        bgcolor: tile,
        borderRadius: `${Math.round(size / 4)}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Box sx={{ width: size * 0.38, height: size * 0.38, bgcolor: mark, transform: 'rotate(45deg)', borderRadius: '2px' }} />
    </Box>
  );
}
